export default "__VITE_ASSET__CCDWQHQi__"